import { render } from "./PaymentPlanModalSectionBilling.vue?vue&type=template&id=b522d94e&scoped=true"
import script from "./PaymentPlanModalSectionBilling.vue?vue&type=script&lang=js"
export * from "./PaymentPlanModalSectionBilling.vue?vue&type=script&lang=js"

import "./PaymentPlanModalSectionBilling.vue?vue&type=style&index=0&id=b522d94e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b522d94e"]])

export default __exports__